import { useEffect } from 'react';
import styled from 'styled-components';

interface Props {
  pattern: any;
  setPattern: (pattern: any) => void;
}

const SpecialPatternOption = ({ pattern, setPattern }: Props) => {
  const handleSpecialConditionChange = (value: string) => {
    console.log('cc', value);
    setPattern({ ...pattern, specialConditionOption: value });
  };
  const togglePatternOption = (key: string) => {
    setPattern({ ...pattern, [key]: pattern[key] === 'N' ? 'Y' : 'N' });
  };

  const checkOptions = [
    { key: 'hugCondition', label: 'HUG인수 조건변경' },
    { key: 'tenantsOpposition', label: '임차인 대항력' },
    { key: 'wageBond', label: '임금채권' },
    { key: 'resale', label: '재매각' },
    { key: 'violatingBuilding', label: '위반건축물' },
    { key: 'statutoryLandRights', label: '법정지상권' },
    { key: 'graveSiteRights', label: '분묘기지권' },
    { key: 'lien', label: '유치권' },
  ];

  useEffect(() => {
    const hasYValue = Object.keys(pattern).some((key) => pattern[key] === 'Y');
    console.log('hasYValue', hasYValue);
    if (hasYValue && pattern.specialConditionOption === 'C') {
      setPattern({
        ...pattern,
        specialConditionOption: 'B',
      });
    }
  }, [pattern, setPattern]);

  return (
    <AllOptionBox>
      <AllOptionBoxContent>
        <ViewOption>
          <span>보기옵션</span>
          <ViewOptionInputBox>
            {[
              { value: 'A', label: '모두 해당' },
              { value: 'B', label: '1개 이상 포함' },
              { value: 'C', label: '해당 없음' },
            ].map((option) => (
              <ViewOptionInputItem key={option.value}>
                <input
                  type="radio"
                  name="specialCondition"
                  value={option.value}
                  checked={pattern.specialConditionOption === option.value}
                  onChange={() => handleSpecialConditionChange(option.value)}
                />
                <span>{option.label}</span>
              </ViewOptionInputItem>
            ))}
          </ViewOptionInputBox>
          <Description>
            {pattern.specialConditionOption === 'A'
              ? '선택한 조건이 모두 해당하는 물건을 검색합니다.'
              : pattern.specialConditionOption === 'B'
                ? '선택한 조건을 1개 이상 포함하는 물건을 검색합니다.'
                : '선택한 조건에 해당되지않는 물건을 검색합니다.'}
          </Description>
        </ViewOption>
        <Block>
          <BlockContent>
            {checkOptions.map(({ key, label }) => (
              <OptionItem key={key} onClick={() => togglePatternOption(key)}>
                <img
                  src={`/assets/images/check/${pattern[key] === 'Y' ? 'check-blue-on' : 'check-blue-off'}.svg`}
                  alt="Check"
                />
                <span>{label}</span>
              </OptionItem>
            ))}
          </BlockContent>
        </Block>
      </AllOptionBoxContent>
    </AllOptionBox>
  );
};

export default SpecialPatternOption;

const AllOptionBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #fff;
`;
const AllOptionBoxContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ViewOption = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  color: #171e26;
  // padding: 24px;
  border-bottom: 1px solid #e1e2e4;
`;
const ViewOptionInputBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  // white-space: nowrap;
  // jusify-content: flex-start;
`;
const ViewOptionInputItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  line-height: 20.3px;
  color: #171e26;
  cursor: pointer;
`;
const Description = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.56);
  padding-bottom: 24px;
`;
const Block = styled.div`
  padding-top: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  color: rgba(23, 30, 38, 0.78);
  // border-bottom: 1px solid #e1e2e4;
`;
const BlockTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 700;
  color: #222;
`;
const BlockContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
`;
const OptionItem = styled.div`
  display: flex;
  width: calc((100% - 8px) / 2);
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  gap: 8px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.78);
  white-space: nowrap;
`;
